/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";

import "./style.css";
import { isIOS } from "react-device-detect";

export interface ITeamDatumProps {
    social?: [
        {
            name: "twitter" | "facebook" | "instagram" | "linkedin";
            link: string;
        }
    ];
    name: string;
    designation: string;
    description?: string;
    image?: string;
}

export interface ITeamProps {
    teamSectionId?: string;
    teamLabel?: string;
    teamDescription?: string;
    teamData?: ITeamDatumProps[];
}

export const Team = ({
    teamSectionId,
    teamLabel,
    teamDescription,
    teamData
}: ITeamProps) => {
    const _renderHeader = () => {
        return (
            <header className="section-header">
                <h2>{teamLabel}</h2>
                {teamDescription && <p>{teamDescription}</p>}
            </header>
        );
    };

    const _renderSocial = (social: any) => {
        let _comp: any = [];
        if (social) {
            social?.forEach((_social: any, index: number) => {
                if (_social?.name === "twitter") {
                    _comp.push(
                        <a
                            key={`social-twitter-${index}`}
                            href={_social?.link ?? ""}
                        >
                            <i className="bi bi-twitter" />
                        </a>
                    );
                }
                if (_social?.name === "facebook") {
                    _comp.push(
                        <a
                            key={`social-facebook-${index}`}
                            href={_social?.link ?? ""}
                        >
                            <i className="bi bi-facebook" />
                        </a>
                    );
                }
                if (_social?.name === "instagram") {
                    _comp.push(
                        <a
                            key={`social-instagram-${index}`}
                            href={_social?.link ?? ""}
                        >
                            <i className="bi bi-instagram" />
                        </a>
                    );
                }
                if (_social?.name === "linkedin") {
                    _comp.push(
                        <a
                            key={`social-linkedin-${index}`}
                            href={_social?.link ?? ""}
                        >
                            <i className="bi bi-linkedin" />
                        </a>
                    );
                }
            });
        }
        return _comp;
    };

    const _renderTeam = () => {
        let _aos_props: any = {};
        if (!isIOS) {
            _aos_props = {
                "data-aos": "fade-up",
                "data-aos-delay": "100"
            };
        }
        const _comp: any = [];
        if (teamData) {
            teamData?.forEach((data, index) => {
                _comp.push(
                    <div
                        key={`landing-page-team-${index}`}
                        className="col-lg-3 col-md-6 d-flex align-items-stretch"
                        {..._aos_props}
                    >
                        <div className="member">
                            <div className="member-img">
                                {data?.image && (
                                    <>
                                        <img
                                            src={data.image}
                                            className="img-fluid"
                                            alt=""
                                            // style={{
                                            //   height: "200px",
                                            //   resizeMode: "contain",
                                            // }}
                                        />
                                    </>
                                )}
                                <div className="social">
                                    {_renderSocial(data?.social)}
                                </div>
                            </div>
                            <div className="member-info">
                                {data?.name && <h4>{data.name}</h4>}
                                {data?.designation && (
                                    <span>{data.designation}</span>
                                )}
                                {data?.description && <p>{data.description}</p>}
                            </div>
                        </div>
                    </div>
                );
            });
        }
        return _comp;
    };
    let _aos_props: any = {};
    if (!isIOS) {
        _aos_props = {
            "data-aos": "fade-up"
        };
    }
    return (
        <section id={teamSectionId} className="team">
            <div className="container" {..._aos_props}>
                {_renderHeader()}
                <div className="row gy-4">{_renderTeam()}</div>
            </div>
        </section>
    );
};

Team.defaultProps = {
    teamSectionId: "team",
    teamLabel: "Our Team"
};
